import { render, staticRenderFns } from "./ControlledPdfReader.vue?vue&type=template&id=1a9b0a41&scoped=true"
import script from "./ControlledPdfReader.vue?vue&type=script&lang=js"
export * from "./ControlledPdfReader.vue?vue&type=script&lang=js"
import style0 from "./ControlledPdfReader.vue?vue&type=style&index=0&id=1a9b0a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b0a41",
  null
  
)

export default component.exports